import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MATERIAL_IMPORTS } from '../shared/shared-exports/material.exports';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { Sidebar } from '../shared/components/sidebar/sidebar';
import { GraphqlService } from '../../graphql/graphql.service';
import { GET_NODE } from '../../graphql/baseGraphql.queries';
import { AppStoreService } from '../store/ngrx-signal.store';
import { Breadcrumb } from '../shared/components/breadcrumb/breadcrumb';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [RouterOutlet, ...MATERIAL_IMPORTS, Breadcrumb, Sidebar],

  templateUrl: './page.html',
  styleUrl: './page.scss',
})
export class Page implements OnInit {
  isOpen = true;
  activeMenu = '';
  activeRoute = '';
  openSubmenus: Record<string, boolean> = {};
  showUserMenu = false;

  items: MenuItem[] | undefined;
  home: MenuItem | undefined;
  breadcrumbs: any = [];

  store = inject(AppStoreService);
  apollo = inject(GraphqlService);

  ngOnInit() {
    this.setAndUpdateBreadCrumbs();
  }

  @Input() menuItems: any;
  @Input() parentRoute: any;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  handleMenuClick(menu: any) {
    if (menu?.children?.length) {
      this.openSubmenus[menu.name] = !this.openSubmenus[menu.name];
    } else if (menu.route) {
      this.navigate(menu.route);
    }
    this.activeMenu = menu.name;
  }

  navigate(route: string) {
    this.activeRoute = route;
    this.router.navigate([route]);
  }

  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
  }

  logout() {
    this.showUserMenu = false;
    this.router.navigate(['home']);
  }

  async getBreadcrumbs(route: ActivatedRoute): Promise<any> {
    const breadcrumbs: {
      label: string;
      url: string;
    }[] = [];

    let currentRoute = route.root;
    let url = '';

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const path = currentRoute.snapshot.url.map((s) => s.path).join('/');

      if (path) {
        url += `/${path}`;
      }

      const label = currentRoute?.routeConfig?.data?.['name'];

      if (label) {
        let lastIndex = breadcrumbs.length - 1;

        if (label != breadcrumbs[lastIndex]?.label) {
          if (currentRoute.routeConfig?.data?.['isANode']) {
            let node = await this.getNode(path);

            breadcrumbs.push({
              label: node.name,
              url,
            });

            continue;
          }

          breadcrumbs.push({
            label,
            url,
          });
        }
      }
    }

    return breadcrumbs;
  }

  async setAndUpdateBreadCrumbs() {
    this.breadcrumbs = await this.getBreadcrumbs(this.route);
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(async () => {
      this.breadcrumbs = await this.getBreadcrumbs(this.route);
    });
  }

  async getNode(id: string): Promise<any> {
    let node = await this.apollo.query(GET_NODE, { id });
    return node;
  }
}
